import { IMenuItem } from '@ready/menu.core';

export const cachedMenuItem = {} as IMenuItem;
